exports = module.exports = require("../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.loader{display:flex;align-items:center;justify-content:center;min-height:300px}.loader:after{content:\"\";display:block;width:100px;height:100px;border:10px solid #f5f5f5;border-top-color:#000;border-radius:50%;animation:rotate .75s infinite linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader!./node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.2_mtgpqfwjwwc4gzzdhxqqjlkm5m/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d075ceb4","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/sass-loader@6.0.7_node-sass@4.14.1_webpack@3.12.0/node_modules/sass-loader/lib/loader.js!./node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.2_mtgpqfwjwwc4gzzdhxqqjlkm5m/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 359
// module chunks = 0